import * as React from 'react';
const SvgDownload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.47 14.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V3a.75.75 0 0 0-1.5 0v9.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06zM3.5 16.25a.75.75 0 0 0 0 1.5h13a.75.75 0 0 0 0-1.5z"
    />
  </svg>
);
export default SvgDownload;
